import ApiBase from './apibase';

class Comunes extends ApiBase {
  constructor(config, target = undefined) {
    super('personalizacion', config, target);
  }

  /**
   * Obtiene notas en base a la prioridad ('sugerencia' | 'preferencia')
   * @param {Bool} rellena - indica si rellena con la 2da prioridad si no alcanzan las notas con la prioridad indicada.
   * @param {Number} [cantidad] - hasta cuantos resultados devolver
   * @param {String} tipo - Tipo de prioridad ('sugerencia' o 'preferencia')
   * @param {Number[]} contenidosLeidos - array con los id's de notas que se quieren excluir de la busqueda
   * @param {Number[]} [hours] - en que horas buscar
   * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
   * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
   * @param {String[]} [tags]
   */
  obtenerPorPrioridad(rellena, cantidad = 10, tipo, contenidosLeidos = [], hours = [], daysOfWeek = [], user = true, tags = []) {
    const params = {};

    params.quantity = cantidad <= 0 ? 10 : cantidad;
    params.contenidosLeidos = contenidosLeidos;
    params.priorityType = tipo;
    params.hours = hours;
    params.daysOfWeek = daysOfWeek;
    params.user = user;
    params.tags = tags;
    params.refill = rellena;

    return this.addTask('personalizacion', 'json', [
      {
        name: 'obtener_por_prioridad',
        params
      }
    ]);
  }
}

export default Comunes;



// WEBPACK FOOTER //
// ./~/@ln/personalizacion/comunes.js